export default __webpack_public_path__ + "static/media/angular-logo.7c132fab.png";